import { render, staticRenderFns } from "./TimeOffRequestsCard.vue?vue&type=template&id=f322b154"
import script from "./TimeOffRequestsCard.vue?vue&type=script&lang=js"
export * from "./TimeOffRequestsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports